<template>
  <b-container>
    <b-row align-v="center">
      <b-col>
        <h1>Add Booking</h1>
      </b-col>
      <b-col class="text-right">
        <b-button variant="link" role="navigation" @click="backToBookings">
          Back to Bookings
        </b-button>
      </b-col>
    </b-row>
    <booking-form
      :booking="booking"
      @cancel="backToBookings"
      @saved="onSaved"
    ></booking-form>
  </b-container>
</template>
<script>
import moment from 'moment';
import _ from 'lodash';

import { DEFAULT_BOOKING } from '@/store/modules/bookings';
import BookingForm from './BookingForm';
import { goBack } from '@/mixins';

export default {
  mixins: [goBack],
  components: {
    BookingForm
  },
  data() {
    return {
      booking: _.cloneDeep(DEFAULT_BOOKING)
    };
  },
  methods: {
    setBookingTimeslotToNext() {
      const bookingIntervalDuration = moment.duration(30, 'minutes');

      const start = moment(
        Math.ceil(+moment() / +bookingIntervalDuration) *
          +bookingIntervalDuration
      );

      this.setBookingTimeslot({ start });
    },
    setBookingTimeslot({ start, end }) {
      const startMoment = moment(start);
      const endMoment = end
        ? moment(end)
        : moment(startMoment).add(30, 'minutes');

      this.booking = {
        ...this.booking,
        start: startMoment.format(),
        startDate: startMoment.format('YYYY-MM-DD'),
        startTime: startMoment.format('HH:mm'),
        end: endMoment.format(),
        endDate: endMoment.format('YYYY-MM-DD'),
        endTime: endMoment.format('HH:mm')
      };
    },
    onSaved() {
      this.$notify({
        type: 'success',
        title: 'Success',
        text: 'Booking created.'
      });
      this.backToBookings();
    },
    backToBookings() {
      this.goBack({ name: 'bookings/calendar' });
    }
  },
  created() {
    const { start, end } = this.$route.params;

    if (start) {
      this.setBookingTimeslot({ start, end });
    } else {
      this.setBookingTimeslotToNext();
    }
  }
};
</script>
